import { createGlobalStyle } from 'styled-components';

import 'react-toastify/dist/ReactToastify.min.css';

const GlobalStyle = createGlobalStyle`
  * {
    scroll-behavior: smooth;
  }

  html, body, #root {
    height: 100%;
    margin: 0;
  }

  html {
    word-break: normal;
  }

  #root {
    display: flex;
    flex-direction: column;
  }

  body {
    background-color: #EAEAEA;
    font-family: 'Poppins', sans-serif;
    overflow-x: hidden;

    overflow-y: scroll;

    &.lock-scroll {
      position: fixed;
			left: 0;
			right: 0;
		}
  }

  .MuiFormControl-marginNormal {
    margin-top: 10px;
  }
`;

export default GlobalStyle;
